import React, { FC, useEffect } from 'react';
import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';

export const ErrorPage: FC = () => {
  useEffect(() => {
    sendGlobalErrorProps({
      errorType: 'generalError',
    });
  }, []);

  return <h1>Oops,something went wrong...</h1>;
};
